export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "taskTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Task"])},
        "sectionOne": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Section 1 - Is the statement true or false?"])},
        "choose": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose true or false."])},
        "true": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["True"])},
        "false": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["False"])},
        "sectionTwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Section 2 - Open-ended tasks"])},
        "calculate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Write your answer in the answerbox."])},
        "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Answer:"])},
        "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type your answer here"])},
        "validation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please make sure you have answered all tasks, wrote a NUMBER OR A WORD where needed"])},
        "finish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finish test"])}
      },
      "nl-NL": {
        "taskTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taak"])},
        "sectionOne": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sectie 1 - Is de verklaring goed of fout?"])},
        "choose": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kies goed of fout."])},
        "true": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Goed"])},
        "false": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])},
        "sectionTwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sectie 2 - Taken met een open einde"])},
        "calculate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ je antwoord in de antwoordbox"])},
        "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Antwoord:"])},
        "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ hier uw antwoord."])},
        "validation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zorg er alstublieft voor dat alle opdrachten zijn beantwoord, schrijf een GETAL of een WOORD waar nodig"])},
        "finish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afwerkingstest"])}
      }
    }
  })
}
